import { d, e } from './chunk-VSVXN4DE.mjs';
import { jsx } from 'react/jsx-runtime';

var h=d((a,l)=>{(function(){var f={}.hasOwnProperty;function e(){for(var n=[],i=0;i<arguments.length;i++){var t=arguments[i];if(t){var s=typeof t;if(s==="string"||s==="number")n.push(this&&this[t]||t);else if(Array.isArray(t))n.push(e.apply(this,t));else if(s==="object"){if(t.toString!==Object.prototype.toString&&!t.toString.toString().includes("[native code]")){n.push(t.toString());continue}for(var o in t)f.call(t,o)&&t[o]&&n.push(this&&this[o]||o);}}}return n.join(" ")}typeof l!="undefined"&&l.exports?(e.default=e,l.exports=e):typeof define=="function"&&typeof define.amd=="object"&&define.amd?define("classnames",[],function(){return e}):window.classNames=e;})();});var r=e(h());var m=({children:f,element:e,className:n})=>{let i={h1:"text-5xl",h2:"text-4xl",h3:"text-3xl",h4:"text-2xl",h5:"text-xl",h6:"text-lg"},t=r.default.bind(i),s=e||"h1";return jsx(s,{className:t(n,[s],"ui-hyphens-auto ui-font-bold"),children:f})};/*! Bundled license information:

classnames/bind.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)
*/

export { m as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-EISPITXV.mjs.map